import { ISO_MATERIAL_SEARCH_FORM, ISO_WELD_LOG_SEARCH_FORM, WELDING_GAS_SEARCH_FORM, WELDING_MACHINE_CALLIBRATION_SEARCH_FORM, WELDING_WPQ_SEARCH_FORM } from "../../../components/common/api";
import { axiosInstance } from "../../../components/common/interceptor";
import {
  fetchIsoMaterialGlobalSearchStart,
  fetchIsoMaterialGloabalSearchSuccess,
  fetchIsoMaterialGloabalSearchFailure,
  fetchWeldingGasGlobalSearchStart,
  fetchWeldingGasGloabalSearchSuccess,
  fetchWeldingGasGloabalSearchFailure,
  fetchMachineCertificationGlobalSearchStart,
  fetchMachineCertificationGloabalSearchSuccess,
  fetchMachineCertificationGloabalSearchFailure,
  fetchWeldingOperatorsGlobalSearchStart,
  fetchWeldingOperatorsGloabalSearchSuccess,
  fetchWeldingOperatorsGloabalSearchFailure,
  fetchIsoWeldLogGlobalSearchStart,
  fetchIsoWeldLogGloabalSearchSuccess,
  fetchIsoWeldLogGloabalSearchFailure,
} from "../../reducer/GlobalSearchReducer/GlobalSearchReducer";


const isGetGlobalSearchWeldingGasList = { value: false };
const isGetGlobalSearchIsoMaterialList = { value: false };
const isGetGlobalSearchWeldingOperatorsList = { value: false };
const isGetGlobalSearchMachineCertificationList = { value: false };
const isGetGlobalSearchIsoWeldLogList = { value: false };

const createGlobalSearchAction = (actionType, apiUrl, flagRef) => {
  return (currentPage, searchKey, itemsPerPage, searchTerm) => {
    return async (dispatch) => {
      if (flagRef.value) return;
      flagRef.value = true;
      dispatch(actionType.start());
      try {
        const params = {
          page: currentPage,
          size: itemsPerPage,
        };

        if (searchKey) {
          params.search_key = searchKey;
        }

        if (searchTerm && searchTerm.trim() !== "") {
          params.search = searchTerm;
        }
        const response = await axiosInstance.get(apiUrl, { params });
        dispatch(
          actionType.success({
            data: response?.data?.result,
            totalCount: response?.data?.result?.totalCount,
          })
        );
      } catch (error) {
        dispatch(
          actionType.failure(
            error.response ? error.response.data : "An error occurred"
          )
        );
      } finally {
        flagRef.value = false;
      }
    };
  };
};

// Action creator for ISO Material
export const GetGloabalSearchIsoMaterialList = createGlobalSearchAction(
  {
    start: fetchIsoMaterialGlobalSearchStart,
    success: fetchIsoMaterialGloabalSearchSuccess,
    failure: fetchIsoMaterialGloabalSearchFailure,
  },
  ISO_MATERIAL_SEARCH_FORM,
  isGetGlobalSearchIsoMaterialList
);

// Action creator for Welding Gas
export const GetGloabalSearchWeldingGasList = createGlobalSearchAction(
  {
    start: fetchWeldingGasGlobalSearchStart,
    success: fetchWeldingGasGloabalSearchSuccess,
    failure: fetchWeldingGasGloabalSearchFailure,
  },
  WELDING_GAS_SEARCH_FORM,
  isGetGlobalSearchWeldingGasList
);

// Action creator for Machine Certification
export const GetGloabalSearchMachineCertificationList = createGlobalSearchAction(
  {
    start: fetchMachineCertificationGlobalSearchStart,
    success: fetchMachineCertificationGloabalSearchSuccess,
    failure: fetchMachineCertificationGloabalSearchFailure,
  },
  WELDING_MACHINE_CALLIBRATION_SEARCH_FORM,
  isGetGlobalSearchWeldingOperatorsList
);

// Action creator for Welding Operators
export const GetGloabalSearchWeldingOperatorsList = createGlobalSearchAction(
  {
    start: fetchWeldingOperatorsGlobalSearchStart,
    success: fetchWeldingOperatorsGloabalSearchSuccess,
    failure: fetchWeldingOperatorsGloabalSearchFailure,
  },
  WELDING_WPQ_SEARCH_FORM,
  isGetGlobalSearchMachineCertificationList
);


// Action creator for Welding Gas
export const GetGloabalSearchIsoWeldLogList = createGlobalSearchAction(
  {
    start: fetchIsoWeldLogGlobalSearchStart,
    success: fetchIsoWeldLogGloabalSearchSuccess,
    failure: fetchIsoWeldLogGloabalSearchFailure,
  },
  ISO_WELD_LOG_SEARCH_FORM,
  isGetGlobalSearchIsoWeldLogList
);
